import {AxiosCall} from '../axios';
import {ServiceSuccessResponseType} from './service-mappers/BaseMapper';

export type VoiceAssistantInteractionMode = 'chat' | 'voice';

export type VoiceAssistantClinicConfig = {
  short_code: string;
  clinic_id: number;
  clinic_group_id: number;
  practice_phone?: string;
  available_languages?: string[];
  voice_button_enabled?: boolean;
  otp_send_cooldown_seconds?: number;
  clinic_details: {
    id: number;
    name: string;
    address?: string;
    address_line_2?: string;
    city?: string;
    state?: string;
    zip?: string;
    country?: string;
    phone?: string;
    billing_phone?: string;
  };
  clinic_group_details: {
    id: number;
    group_name?: string;
  };
};

export type VoiceAssistantConnectionDetails = {
  serverUrl: string;
  roomName: string;
  participantName: string;
  participantToken: string;
  dispatchToken: string;
};

export function fetchVoiceAssistantWebConfig({
  shortCode
}: {
  shortCode: string;
}): Promise<ServiceSuccessResponseType<VoiceAssistantClinicConfig>> {
  return AxiosCall.get(
    `/voice-assistant/web/${encodeURIComponent(shortCode)}/config`
  );
}

export function fetchVoiceAssistantWebPrefill({
  shortCode,
  paymentToken
}: {
  shortCode: string;
  paymentToken: string;
}): Promise<ServiceSuccessResponseType<{patient_phone: string}>> {
  return AxiosCall.get(
    `/voice-assistant/web/${encodeURIComponent(
      shortCode
    )}/prefill/${encodeURIComponent(paymentToken)}`
  );
}

export function sendVoiceAssistantWebOtp({
  shortCode,
  patientPhone,
  resend = false
}: {
  shortCode: string;
  patientPhone: string;
  resend?: boolean;
}): Promise<ServiceSuccessResponseType<null>> {
  return AxiosCall.post(
    `/voice-assistant/web/${encodeURIComponent(shortCode)}/send-otp`,
    {
      patient_phone: patientPhone,
      resend
    }
  );
}

export function verifyVoiceAssistantWebOtp({
  shortCode,
  patientPhone,
  otp
}: {
  shortCode: string;
  patientPhone: string;
  otp: string;
}): Promise<ServiceSuccessResponseType<{verification_token: string}>> {
  return AxiosCall.post(
    `/voice-assistant/web/${encodeURIComponent(shortCode)}/verify-otp`,
    {
      patient_phone: patientPhone,
      otp
    }
  );
}

export function createVoiceAssistantWebConnection({
  shortCode,
  patientPhone,
  interactionMode,
  verificationToken,
  language
}: {
  shortCode: string;
  patientPhone: string;
  interactionMode: VoiceAssistantInteractionMode;
  verificationToken: string;
  language?: string;
}): Promise<ServiceSuccessResponseType<VoiceAssistantConnectionDetails>> {
  return AxiosCall.post(
    `/voice-assistant/web/${encodeURIComponent(shortCode)}/connection-details`,
    {
      patient_phone: patientPhone,
      interaction_mode: interactionMode,
      interactive_options: interactionMode === 'chat',
      verification_token: verificationToken,
      language
    }
  );
}

export function startVoiceAssistantWebAgent({
  shortCode,
  dispatchToken
}: {
  shortCode: string;
  dispatchToken: string;
}): Promise<ServiceSuccessResponseType<{started: boolean}>> {
  return AxiosCall.post(
    `/voice-assistant/web/${encodeURIComponent(shortCode)}/start-agent`,
    {
      dispatch_token: dispatchToken
    }
  );
}
